/**
 * user agent
 */

import UAParser from 'ua-parser-js';

export function ua() {

	// ユーザー環境取得
	const uaParser = new UAParser();
	const uaResult = uaParser.getResult();

	// タッチデバイス判定
	let touchDevice = false;
	if ('ontouchend' in document) {
		touchDevice = true;
	}

	// デバイス判定
	let device = {
		os: uaResult.os.name,
		type: null
	};

	if (uaResult.device.type === 'mobile') {
		device.type = 'mobile';
	} else if (uaResult.device.type === 'tablet' || uaResult.os.name === 'Mac OS' && touchDevice || uaResult.device.type === 'desktop' && touchDevice) {
		device.type = 'tablet';
	} else {
		device.type = 'desktop';
	}

	return device;
}


// WEBPACK FOOTER //
// ./src/externals/ua.js